export enum GlobalStep {
    SELECTOR = 'selector',
    CONFIGURATION = 'configuration',
    PRICE_DETAIL = 'price-detail',
    CUSTOMER_DATA = 'customer-data',
    SUMMARY = 'summary',
    CONGRATULATIONS = 'congratulations',
}
